import React from 'react';

function Error({ errorMessage }) {
	return (
		<div className='container'>
			<div className='alert alert-danger mt-20 mb-20'>
				{errorMessage
					? errorMessage
					: 'The page you are looking for is not available at the moment. Please try again later.'}
			</div>
		</div>
	);
}

export default Error;
